import {useEffect, useState} from 'react';
import deliveryVan from '@img/delivery-van-svgrepo-com.svg';

interface LoaderProps {
    visible?: boolean;
    opaque?: boolean;
}

const LOADER_FADE_MS = 450;

export default function Loader({visible = true, opaque = false}: LoaderProps) {
    const [rendered, setRendered] = useState<boolean>(visible);
    const [showLoader, setShowLoader] = useState<boolean>(false);

    useEffect(() => {
        if (visible) {
            setRendered(true);
            // Defer class toggle so CSS transition can run on enter.
            const raf = requestAnimationFrame(() => setShowLoader(true));
            return () => cancelAnimationFrame(raf);
        }

        setShowLoader(false);
        const timer = setTimeout(() => setRendered(false), LOADER_FADE_MS);
        return () => clearTimeout(timer);
    }, [visible]);

    if (!rendered) {
        return null;
    }

    return (
        <div className={'loader' + (showLoader ? ' show' : '') + (opaque ? ' opaque' : '')}>
            <div className="loader-car">
                <div className="loader-child">
                    <img src={deliveryVan} alt="Delivery Van" className='loader-van' />
                    <span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </div>
            </div>
        </div>
    );
}
